import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const AgainTrain = async (params: object) => {
  return await GET({ url: Api.AgainTrain, params, showError: false })
}
export const getMainData = async (params: object) => {
  return await GET({ url: Api.getMainData, params, showError: false })
}
